import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Input, Checkbox, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {toUpperCase} from '../../../common/util/fieldsNormalization';

class LocationRow extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
  }

  checkWarehouse(value) {
    const {location} = this.props;
    return location.warehouses.indexOf(value) !== -1;
  }

  checkZone(value) {
    const {location} = this.props;
    return location.pickingZone === value;
  }

  handleChange(event, data) {
    const {value, name} = data;
    const isTextValue = typeof value === 'string';
    const fieldValue = isTextValue ? toUpperCase(value) : value;
    this.props.changeSelectedLocationValue(this.props.index, name, fieldValue);
  }

  handleSelection(event, data) {
    this.props.changeSelectedLocationWarehouses(this.props.index, data.value);
  }

  handleRemoveClick(index) {
    this.props.removeWarehouseLocation(index);
  }

  renderLocationFields() {
    const {location} = this.props;

    return (
      <Grid>
        <Grid.Row columns={5}>
          <Grid.Column>
            <Input
              name='aisle'
              maxLength='4'
              value={location.aisle}
              onChange={this.handleChange}
              size='mini'
              required
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              name='module'
              maxLength='1'
              value={location.module}
              onChange={this.handleChange}
              size='mini'
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              name='level'
              maxLength='1'
              value={location.level}
              onChange={this.handleChange}
              size='mini'
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              name='sequential'
              maxLength='2'
              value={location.sequential}
              onChange={this.handleChange}
              size='mini'
            />
          </Grid.Column>
          <Grid.Column>
            <Input
              name='binType'
              maxLength='2'
              value={location.binType}
              onChange={this.handleChange}
              size='mini'
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  
  renderWarehouseField() {
    const {warehouses} = this.props;

    return (
      <Grid>
        <Grid.Row columns={warehouses.length}>
          {this.renderWarehouseCheckBoxes(warehouses)}
        </Grid.Row>
      </Grid>
    );
  }

  renderWarehouseCheckBoxes(warehouses) {
    return warehouses.map((item) => {
      return (
        <Grid.Column key={item.code}>
          <Checkbox
            name='warehouses'
            value={item.code}
            checked={this.checkWarehouse(item.code)}
            onChange={this.handleSelection}
          />
        </Grid.Column>
      );
    });
  }

  renderZoneField() {
    const {zones} = this.props;

    return (
      <Grid>
        <Grid.Row columns={zones.length}>
          {this.renderZonesCheckboxes(zones)}
        </Grid.Row>
      </Grid>
    );
  }

  renderZonesCheckboxes(zones) {
    return zones.map((item) => {
      return (
        <Grid.Column key={item.code}>
          <Checkbox
            name='pickingZone'
            value={item.code}
            checked={this.checkZone(item.code)}
            onChange={this.handleChange}
            radio
          />
        </Grid.Column>
      );
    });
  }

  render() {
    const {index} = this.props;

    return (
      <Grid.Row className='location-row' verticalAlign='middle'>
        <Grid.Column width={5}>
          {this.renderLocationFields()}
        </Grid.Column>
        <Grid.Column width={5}>
          {this.renderWarehouseField()}
        </Grid.Column>
        <Grid.Column width={5}>
          {this.renderZoneField()}
        </Grid.Column>
        <Grid.Column width={1}>
          <Icon name='trash' size='big' onClick={() => this.handleRemoveClick(index)} link />
        </Grid.Column>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => ({});

const {
  removeWarehouseLocation,
  changeSelectedLocationValue,
  changeSelectedLocationWarehouses,
} = Actions;

export default connect(mapStateToProps, {
  removeWarehouseLocation,
  changeSelectedLocationValue,
  changeSelectedLocationWarehouses,
})(LocationRow);
